import { render, staticRenderFns } from "./totip.vue?vue&type=template&id=ccded2ba&scoped=true"
var script = {}
import style0 from "./totip.vue?vue&type=style&index=0&id=ccded2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccded2ba",
  null
  
)

export default component.exports